import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Popover, Select, Space, notification } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import AdminCompanySelect from '../../components/Admin/AdminCompanySelect';
import { adminGrantCompany } from '../../api/admin';
import { levelHelp, levelOptions } from './accessLevelHelp';

type GrantCompanyModalProps = {
  open: boolean;
  onCancel: () => void;
  selectedUserEmail?: string;
  selectedUserId?: string;
  onSuccess?: (uid?: string) => void;
};

const levelLabel = (
  <Space size={6}>
    <span>Level</span>
    <Popover content={levelHelp} placement="right">
      <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
    </Popover>
  </Space>
);

const GrantCompanyModal: React.FC<GrantCompanyModalProps> = ({
  open,
  onCancel,
  selectedUserEmail,
  selectedUserId,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const initialValues = {
    uid: selectedUserId,
    level: 80,
  };

  const handleGrant = async (values: any) => {
    try {
      setLoading(true);
      await adminGrantCompany(values);
      notification.success({
        message: 'Company access granted',
        description: 'Company access was updated successfully.',
        placement: 'topRight',
      });
      onSuccess?.(values?.uid);
      form.resetFields();
      onCancel();
    } catch (e: any) {
      notification.error({
        message: 'Grant company access failed',
        description: e?.message || String(e),
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues.uid]);
  return (
    <Modal
      title={`Grant Company Access${selectedUserEmail ? ` — ${selectedUserEmail}` : ''}`}
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleGrant} initialValues={initialValues}>
        <Form.Item name="uid" hidden />
        <Form.Item name="companyId" label="Company" rules={[{ required: true }]}>
          <AdminCompanySelect />
        </Form.Item>
        <Form.Item name="level" label={levelLabel} initialValue={80}>
          <Select options={levelOptions} />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button onClick={onCancel} disabled={loading}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>Grant</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GrantCompanyModal;
